<div class="collapse-section">
  <a (click)="toggle()">
    {{ expanded ? collapseLabel : expandLabel }}
  </a>
  @if (expanded) {
    <div class="content">
      <ng-content></ng-content>
    </div>
  }
</div>